export default __webpack_public_path__ + "static/media/decada-2010-0008-min.329fe71b.jpg";